import React , { useState } from 'react'
import ModalCapsuleImage from "../assets/images/reeddicapsule/modal-capsule.png"

const ModalContext = React.createContext()

function ModalContextProvider({ children }){
    let [toggleDrawer, setToggleDrawer] = useState(false)
    let [getImage, setImage] = useState(ModalCapsuleImage)
    let [modalPaymentLink, setPaymentLink] = useState('https://paystack.shop/reeddi-capsule')
	function handleToggle(arg){

		if(toggleDrawer === arg){
			return setToggleDrawer(null)
		}
		setToggleDrawer(arg)

	}

    return(
        <ModalContext.Provider
            value={
                {
                    toggleDrawer,
                    handleToggle,
                    getImage,
                    setImage,
                    modalPaymentLink,
                    setPaymentLink
                }
            }
        >
            { children }
        </ModalContext.Provider>
    )
}

export { ModalContext, ModalContextProvider }
